import styles from "./styles.module.css";

export default function RegistrosRondaColaboradoresContagem({ registros, filtro }: iProps) {
    if (registros.length === 0) {
        return <div></div>;
    }

    let colaboradores: any[] = [];
    for (let reg of registros) {
        let id_colaborador = reg.id_colaborador;
        if (colaboradores.filter((reg) => reg.id === id_colaborador).length > 0) {
            continue;
        }
        colaboradores.push({
            id: reg.id_colaborador,
            nome_completo: reg.nome_completo,
            quantidade: 0,
        });
    }
    for (let reg of registros) {
        let id_colaborador = reg.id_colaborador;
        for (let idx in colaboradores) {
            if (colaboradores[idx].id === id_colaborador) {
                colaboradores[idx].quantidade += 1;
                break;
            }
        }
    }

    return (
        <div>
            <p className={styles.contagemTitulo}>Rondas por Colaboradores</p>
            <div className="div-row" style={{ alignItems: "start" }}>
                <div style={{ lineHeight: "25px", textAlign: "justify" }}>
                    {colaboradores
                        .sort((a, b) => a.id - b.id)
                        .map((col, idx, arr) => {
                            if (idx % 2 === 1) {
                                return <div key={idx}></div>;
                            }
                            return (
                                <div key={idx} className={styles.qtdRegPorDia}>
                                    <span>
                                        {col.nome_completo} <b>{col.quantidade}</b>
                                    </span>
                                </div>
                            );
                        })}
                </div>
                <div style={{ lineHeight: "25px", textAlign: "justify" }}>
                    {colaboradores
                        .sort((a, b) => a.id - b.id)
                        .map((col, idx, arr) => {
                            if (idx % 2 === 0) {
                                return <div key={idx}></div>;
                            }
                            return (
                                <div key={idx} className={styles.qtdRegPorDia}>
                                    <span>
                                        {col.nome_completo} <b>{col.quantidade}</b>
                                    </span>
                                </div>
                            );
                        })}
                </div>
            </div>
            <br></br>
        </div>
    );
}
interface iProps {
    registros: any[];
    filtro: any;
}
